<template>
  <div class="About">
    <top-page-title>За нас</top-page-title>
    <section class="section bg-grey-lightest py-12">
      <div class="container">
        <p class="text-center text-xl mb-8 font-light">
          Екип от млади и готини авто и мото ентусиасти в търсене на най-добрите МПС експерти. Идеята на Платформата ни е да споделим с теб
          удоволствието от шофирането и да създаваме щастие. Включи се в надпреварата! Спечели едно страхотно МПС.
        </p>
        <!--        <about-slider/>-->
      </div>
    </section>
    <background-section
      id="StatsSection"
      image="sections/next_rounds.jpg"
      class="section bg-grey-lightest pt-10 border-dark-red border-t-4"
    >
      <div class="container flex justify-center">
        <div class="w-2/3 flex flex-col lg:flex-row -mx-8 justify-center">
          <div class="mb-10 lg:mb-0 mx-8">
            <about-stat
              :number="stats.users"
              icon="mps-people"
              text="Регистрирани"
            />
          </div>
          <div class="mb-10 lg:mb-0 mx-8">
            <about-stat
              :number="stats.cars"
              icon="mps-car"
              text="Спечелени коли"
            />
          </div>
          <div class="mb-10 lg:mb-0 mx-8">
            <about-stat
              :number="stats.bonuses"
              icon="mps-prize"
              text="Раздадени бонуси"
            />
          </div>
        </div>
        <div class="hidden lg:block w-1/3">
          <img
            class="-mt-12 max-w-none"
            src="@/assets/images/sections/stats-section-car.png"
            width="650"
            alt=""
          >
        </div>
      </div>
    </background-section>
    <background-section
      image="sections/testimonials.jpg"
      class="section bg-black py-12"
    >
      <div class="container text-center">
        <fancy-heading
          title="Отзиви"
          subtitle="за нас"
          mode="dark"
        />
        <div class="md:w-2/3 mx-auto">
          <home-testimonials/>
        </div>
      </div>
    </background-section>
  </div>
</template>

<script>
import AboutStat from '@/components/AboutStat'
import AboutSlider from '@/components/AboutSlider'
import HomeTestimonials from '@/components/HomeTestimonials'

export default {
  name: 'About',
  components: { AboutStat, HomeTestimonials, AboutSlider },
  data () {
    return {
      stats: {
        users: 0,
        cars: 0,
        bonuses: 0
      }
    }
  },
  async mounted () {
    try {
      this.stats = await this.$api.getData('/statistics')
    } catch (err) {
      this.$displayError(err)
    }
  }
}
</script>

<style rel='stylesheet/scss' lang='scss'>
@import '~utils';

</style>
